module.exports = __webpack_public_path__ + "img/charging-hub-in-progress-proprietary.b7775027.svg";